// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y5UAj","col":"styles_col__2zBU0"};